import React from 'react';
import classNames from 'classnames';
import { sortBy } from 'lodash';
import { Icon } from 'ui';
import { hasFeatureFlags } from 'utils/features';
import { routes } from '../../../constants/config';
import CustomGroupsList from './CustomGroupsList';

class CustomGroups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  toggleExpand() {
    this.setState(state => ({
      expanded: !state.expanded,
    }));
  }

  getNestedGroups() {
    const { groups } = this.props;
    const treeList = [];
    const lookup = {};
    groups.forEach(group => {
      lookup[group.id] = group;
      group.children = [];
    });
    groups.forEach(group => {
      if (group.parentId !== null) {
        lookup[group.parentId].children.push(group);
      } else {
        treeList.push(group);
      }
    });
    return treeList;
  }

  render() {
    const {
      groups,
      activeGroup,
      updateActiveGroup,
      updateMyOrganization,
      canAddPeople,
      toggleGroupsList,
      groupsListVisible,
    } = this.props;
    const hasGroups = groups.length > 0;
    const hasNoGroups = groups.length === 0;
    const notExpandedAndHasNoGroups = hasNoGroups && !this.state.expanded;
    const showIcon = hasGroups || notExpandedAndHasNoGroups;
    const iconStyle = classNames({
      'NestedList-icon': true,
      'mr-4': true,
      'NestedList-icon--rotated': this.state.expanded,
    });
    const hasUnificationFeatureFlag = hasFeatureFlags([
      'readiness-enable-unification',
    ]);

    return (
      <div className="CustomGroups mt-16">
        <div className="NestedList-header">
          <div className="fw-b">
            <span
              className={iconStyle}
              aria-label={t('groups.custom.name')}
              onClick={this.toggleExpand}
              role="button"
              tabIndex="0"
              onKeyDown={e => {
                if (e.key === 'ArrowDown') {
                  this.toggleExpand();
                }
              }}
              onKeyUp={e => {
                if (e.key === 'ArrowUp') {
                  this.toggleExpand();
                }
              }}
            >
              <Icon
                name="triangle_down"
                className="Icon--small c-brand-gray c-p"
              />
            </span>
            <span
              className="mr-4 c-p"
              onClick={this.toggleExpand}
              role="button"
              tabIndex="0"
              onKeyDown={e => {
                if (e.key === 'ArrowDown') {
                  this.toggleExpand();
                }
              }}
              onKeyUp={e => {
                if (e.key === 'ArrowUp') {
                  this.toggleExpand();
                }
              }}
            >
              {t('groups.custom.name')}
            </span>
            {canAddPeople && showIcon && (
              <span
                className="h-ci"
                data-toggle="tooltip"
                title={t('groups.custom.description')}
                data-placement="top"
                role="button"
                tabIndex="0"
                aria-label={t('groups.custom.description')}
              >
                <Icon
                  name="info"
                  className="NestedList-headerIcon c-brand-gray"
                />
              </span>
            )}
          </div>
          {canAddPeople && showIcon && !hasUnificationFeatureFlag && (
            <div>
              <a
                href={routes.NEW_GROUP}
                className="ButtonWithTooltip fz-base"
                data-tooltip={t('groups.custom.new')}
                aria-label={t('groups.custom.new')}
              >
                <Icon
                  name="add"
                  className="NestedList-headerIcon c-brand-gray fz-bigger"
                />
              </a>
            </div>
          )}
        </div>
        {this.state.expanded && (
          <div className="d-f fd-c">
            {hasNoGroups && (
              <div className="NestedList-item">
                <div className="mb-8 c-brand-gray-dark">
                  {t('groups.custom.description')}
                </div>
                {canAddPeople && !hasUnificationFeatureFlag && (
                  <a
                    className="NewButton NewButton--white mb-8 h-td-n h-c-gray-darkest"
                    href={routes.NEW_GROUP}
                  >
                    <Icon name="add" className="c-brand-gray-dark mr-4" />
                    {t('groups.custom.new')}
                  </a>
                )}
              </div>
            )}
            {sortBy(this.getNestedGroups(), 'name').map(group => (
              <CustomGroupsList
                group={group}
                key={group.id}
                activeGroup={activeGroup}
                updateActiveGroup={updateActiveGroup}
                updateMyOrganization={updateMyOrganization}
                toggleGroupsList={toggleGroupsList}
                groupsListVisible={groupsListVisible}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default CustomGroups;
